import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'a-unit',
    templateUrl: './a-unit.component.html',
    styleUrls: ['./a-unit.component.scss'],
    standalone: false
})
export class AUnitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
